import { Menu } from "antd";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { CgMathEqual } from "react-icons/cg";
import { MdOutlineDashboard } from "react-icons/md";
import { useLocation, useNavigate } from "react-router-dom";

import { LegalPageAppDownloadLinks } from "../../components/Constants";
import "./home.scss";
import { sideMenuItems } from "./sideMenuItems";

const SideBarMenu = () => {
  const [faqSections, setFaqsections] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    getFaqSections();
  }, []);

  // useEffect(() => {
  //   window.scrollTo(0, 0);
  // }, [location.pathname]);

  const getFaqSections = () => {
    axios
      .post(`${process.env.REACT_APP_API_URL}faq-section/list`)
      .then((response) => {
        if (response?.data?.rows?.length) {
          const faqSideMenus = response?.data?.rows.map((data, inx) => ({
            key: `s12${inx}`,
            label: data.name,
            path: `faq/${data.slugurl}`,
          }));
          setFaqsections({
            key: "s12",
            label: "FAQ's",
            icon: <CgMathEqual size={20} />,
            children: faqSideMenus,
          });
        }
      })
      .catch((err) => {
        console.error(err);
        alert("Some error");
      });
  };
  // const [collapsed, setCollapsed] = useState(false);
  // const toggleCollapsed = () => {
  //   setCollapsed(!collapsed);
  // };
  const [openKeys, setOpenKeys] = useState([]);

  const handleClick = ({ item, key, keyPath, domEvent, ...rest }) => {
    if (item.props?.path) {
      navigate(`/${item.props.path}`);
      window.scrollTo(0, 0);
    }
  };
  const menuItems = [...sideMenuItems, faqSections];
  const [selectedKey, setSelectedKey] = useState([]);

  const escapeRegExp = (string) =>
    string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

  const findMatchingKeyPath = (items, pathname, path = []) => {
    for (const item of items) {
      const currentPath = [...path, item.key];

      if (item.path) {
        // Normalize leading slashes for matching
        const normalizedItemPath = "/" + item.path.replace(/^\/+/, "");
        const escapedPath = escapeRegExp(normalizedItemPath);
        const pattern = new RegExp(`^${escapedPath}(\\/|\\?|$)`);
        if (pattern.test(pathname)) {
          return currentPath;
        }
      }

      if (item.children) {
        const childPath = findMatchingKeyPath(
          item.children,
          pathname,
          currentPath
        );
        if (childPath) return childPath;
      }
    }
    return null;
  };

  useEffect(() => {
    const keyPath = findMatchingKeyPath(menuItems, location.pathname);
    if (keyPath && keyPath.length > 0) {
      setSelectedKey([keyPath[keyPath.length - 1]]);
      setOpenKeys(keyPath.slice(0, -1));
    }
  }, [location.pathname]);

  return (
    <aside className="sideMenuWrapper">
      <Menu
        defaultSelectedKeys={["1"]}
        defaultOpenKeys={["sub1"]}
        mode="inline"
        selectedKeys={selectedKey}
        openKeys={openKeys}
        onOpenChange={setOpenKeys}
        items={menuItems}
        onClick={handleClick}
      />
    </aside>
  );
};

export default SideBarMenu;
